import { useMutation } from "react-query";
import editSkuPoOcrColumn from "../services/editSkuPoOcrColumn";

function useEditSkuPoOcrColumn() {
  return useMutation(["edit-sku-po-ocr-column"], editSkuPoOcrColumn);
}

export default useEditSkuPoOcrColumn;
